'use strict';

(function () {
    var ASSET_ORIGIN = document.location.origin;
    var ASSET_MANIFEST = '/reservation/asset-manifest.json';

    var GLOBAL_RESSOURCES_TO_PRELOAD = {
        script: ['main.js', 'runtime~main.js', 'runtime-main.js', 'footer.js'],
        style: ['main.css'],
    };

    function preloadAssetsFromAssetManifest() {
        window.fetch &&
            fetch(ASSET_ORIGIN + ASSET_MANIFEST)
                .then(function (response) {
                    return response.json();
                })
                .then(function (response) {
                    preloadFiles(response.files);
                });
    }

    function preloadFiles(assetMap) {
        if (!assetMap) {
            return;
        }

        GLOBAL_RESSOURCES_TO_PRELOAD.script.map(function (scriptName) {
            assetMap[scriptName] && preloadScript(assetMap[scriptName]);
        });

        GLOBAL_RESSOURCES_TO_PRELOAD.style.map(function (scriptName) {
            assetMap[scriptName] && preloadStyle(assetMap[scriptName]);
        });
    }

    function preloadScript(url) {
        preloadUrl(url, 'script');
    }

    function preloadStyle(url) {
        preloadUrl(url, 'style');
    }

    function preloadUrl(url, type) {
        var preloadLink = document.createElement('link');
        preloadLink.href = ASSET_ORIGIN + url;
        preloadLink.rel = hasPrefetchCapability() ? 'prefetch' : 'preload';
        preloadLink.as = type;
        document.head.appendChild(preloadLink);
    }

    function hasPrefetchCapability() {
        var ua = (window.navigator && window.navigator.userAgent) || '';
        return !/safari|ip(hone|(a|o)d)/i.test(ua);
    }

    preloadAssetsFromAssetManifest();
})();
